import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { FieldValues, UseFormReturn } from "react-hook-form";
import CommonFormBuilder from "@/app/components/common-form-builder/CommonFormBuilder";
interface Props {
  fields: IField[];
  form: UseFormReturn<FieldValues, any>;
  className: string;
}

const OtherFields: React.FC<Props> = ({ className, form, fields }) => {
  return (
    <div className={`auth-form  ${className}`}>
      {fields?.map((field) => (
        <CommonFormBuilder
          key={field.configurations.key}
          form={form}
          field={field}
        />
      ))}
    </div>
  );
};
export default OtherFields;
